import React, { useState } from "react";

const EditOverlay = ({ onClose, onSave, titreInitial, descriptionInitial }) => {
  const [titre, setTitre] = useState(titreInitial);
  const [description, setDescription] = useState(descriptionInitial);

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <h3>Modifier la réalisation</h3>

        <label>Titre :</label>
        <input
          type="text"
          value={titre}
          onChange={(e) => setTitre(e.target.value)}
          style={inputStyle}
        />

        <label>Description :</label>
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          style={textareaStyle}
        />

        <div style={{ marginTop: "15px", display: "flex", gap: "10px" }}>
          <button className="btn-primary" onClick={() => onSave(titre, description)}>
            Enregistrer
          </button>
          <button className="btn-secondary" onClick={onClose}>
            Annuler
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditOverlay;

/* --- Styles --- */
const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 999,
};

const modalStyle = {
  background: "#fff",
  padding: "20px",
  borderRadius: "12px",
  width: "400px",
  maxWidth: "90%",
};

const inputStyle = {
  width: "100%",
  padding: "8px",
  marginTop: "5px",
  marginBottom: "10px",
  borderRadius: "6px",
  border: "1px solid #ccc",
};

const textareaStyle = {
  width: "100%",
  minHeight: "80px",
  padding: "8px",
  marginTop: "5px",
  borderRadius: "6px",
  border: "1px solid #ccc",
};
